import { Theme } from "../../Theme";

export const HeaderLogo = {
    width: "5em",
    backgroundColor: Theme.primaryBodyd,
    cursor:"pointer"
}